export default {
  "ai_disclaimer": "AI-generated content may be incorrect",
  "back": "Back",
  "_back.comment": "Used to label buttons and links to navigate to previous page or state",
  "breadcrumb": "Breadcrumb",
  "_breadcrumb.comment": "labels a breadcrumb navigation component",
  "chart_view": "Chart view",
  "citation": "Citation {0}",
  "clear": "Clear",
  "clear_entry": "Clear entry",
  "close": "Close",
  "close_message": "Close message",
  "collapse": "Collapse",
  "collapse_all_rows": "Collapse all rows",
  "collapse_row": "Collapse row",
  "collapse_task_menu": "Collapse task menu",
  "commands": "Commands",
  "complete": "Complete",
  "copilot_chat_window": "Copilot chat window",
  "copilot_placeholder":"Ask a question or request info",
  "copilot_said": "Copilot said:",
  "current": "Current",
  "data_view": "Data view",
  "day": "Day",
  "dislike": "Dislike",
  "error": "Error",
  "expand": "Expand",
  "expand_all_rows": "Expand all rows",
  "expand_row": "Expand row",
  "expand_task_menu": "Menu toggle",
  "filter": "Filter",
  "finish": "Finish",
  "first": "First",
  "generating_response": "Generating a response...",
  "hide_password": "Hide password",
  "last": "Last",
  "like": "Like",
  "loading": "Loading...",
  "max_checked_error_message": "A maximum of {0} checkboxes must be checked.",
  "min_checked_error_message": "At least {0} checkboxes must be checked.",
  "month": "Month",
  "more_info": "More Info",
  "more_options": "More Options",
  "navigation": "Navigation",
  "next": "Next",
  "next_month": "Next month",
  "no_results_found": "No results found",
  "not_started": "Not started",
  "of": "of",
  "off": "Off",
  "on": "On",
  "open": "Open",
  "open_in_new_window": "Open in new window",
  "options": "Options",
  "page": "Page {0}",
  "pagination": "Pagination",
  "plus_x_more": "+{0} more",
  "previous": "Previous",
  "previous_month": "Previous month",
  "progress": "In progress",
  "quick_start": "Quick start",
  "range_error_message": "The date you have selected is not within the date range.",
  "reference": "Reference",
  "references": "References",
  "refresh_suggestions": "Refresh suggestions",
  "remove": "Remove",
  "required": "Required",
  "required_error_message": "This field is required.",
  "x_of_y_responses": "{0} of {1} responses",
  "results_found": "{0} results found",
  "save_as_image": "Save as image",
  "search": "Search",
  "select_all": "Select all",
  "select_row": "Select row",
  "selected_options": "Selected options",
  "send": "Send",
  "show_calendar": "Show calendar",
  "show_less": "Show less",
  "show_more": "Show more ({0})",
  "show_password": "Show password",
  "skip_to_main": "Skip to main content",
  "slide_x_of_y": "Slide {0} of {1}",
  "step_x_of_y": "Step {0} of {1}",
  "stop_generating": "Stop generating",
  "suggested_responses": "Suggested responses",
  "today": "Today",
  "toggle_reference": "Toggle reference {0}",
  "unavailable_date_error_message": "The date you have selected is unavailable.",
  "view_prompts": "View prompts",
  "warning": "Warning",
  "week_number": "Week {0}",
  "x_of_y_stars": "{0} of {1} stars",
  "year": "Year",
  "you_said": "You said:"
}
